import { supabase } from '@/lib/supabase';
import { ProviderServiceError } from './errors';
import { ProviderType, ProviderWithType } from '@/features/providers/types';

export const providerQueries = {
    getProviders: async () => {
        const { data, error } = await supabase
            .from('providers')
.select(`
                id,
                name,
                type_id,
                has_sequence_numbers,
                logo_url,
                logo_filename,
                website_url,
                support_email,
                support_phone,
                free_trial_days,
                student_discount_available,
                currency,
                created_at,
                updated_at,
                type:provider_types!inner(*)
            `)
            .order('name');

        if (error) {
            throw new ProviderServiceError(
                'Failed to fetch providers',
                'FETCH_ERROR',
                error
            );
        }

        // Transform the data to match the ProviderWithType interface
        return (data || []).map(provider => {
            const type = provider.type as unknown as ProviderType; // Cast the type object correctly
            return {
                id: provider.id,
                name: provider.name,
                type_id: provider.type_id,
                has_sequence_numbers: provider.has_sequence_numbers,
                logo_url: provider.logo_url,
                logo_filename: provider.logo_filename,
                website_url: provider.website_url,
                support_email: provider.support_email,
                support_phone: provider.support_phone,
                free_trial_days: provider.free_trial_days,
                student_discount_available: provider.student_discount_available,
                currency: provider.currency,
                created_at: provider.created_at,
                updated_at: provider.updated_at,
                type: {
                    id: type.id,
                    name: type.name,
                    created_at: type.created_at
                }
            };
        }) as ProviderWithType[];
    },

    getProviderById: async (id: number) => {
        const { data, error } = await supabase
            .from('providers')
.select(`
                id,
                name,
                type_id,
                has_sequence_numbers,
                logo_url,
                logo_filename,
                website_url,
                support_email,
                support_phone,
                free_trial_days,
                student_discount_available,
                currency,
                created_at,
                updated_at,
                type:provider_types!inner(*)
            `)
            .eq('id', id)
            .single();

        if (error) {
            throw new ProviderServiceError(
                'Failed to fetch provider',
                'FETCH_ERROR',
                error
            );
        }

        // Transform the data to match the ProviderWithType interface
        const type = data.type as unknown as ProviderType; // Cast the type object correctly
        return {
            id: data.id,
            name: data.name,
            type_id: data.type_id,
            has_sequence_numbers: data.has_sequence_numbers,
            logo_url: data.logo_url,
            logo_filename: data.logo_filename,
            website_url: data.website_url,
            support_email: data.support_email,
            support_phone: data.support_phone,
            free_trial_days: data.free_trial_days,
            student_discount_available: data.student_discount_available,
            currency: data.currency,
            created_at: data.created_at,
            updated_at: data.updated_at,
            type: {
                id: type.id,
                name: type.name,
                created_at: type.created_at
            }
        } as ProviderWithType;
    },

    getProviderTypes: async () => {
        const { data, error } = await supabase
            .from('provider_types')
            .select('id, name, created_at')
            .order('name');

        if (error) {
            throw new ProviderServiceError(
                'Failed to fetch provider types',
                'FETCH_ERROR',
                error
            );
        }

        return data as ProviderType[];
    }
};